module.exports = {
      id: "eye-gray-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#eye-gray",
      toString: function () {
        return this.url;
      }
    }